<template>

<div class='row file-grid-row'>

   <div v-for='(ft,i) in fileTypes' class='col-12'>
        <div class="row">
            <div class="col-12">
                <h6 class="group-sub-title title">
                    {{ ft.name }}
                </h6>

                <dropzone :conf='getConfig(ft)' v-on:upload-success="addFile"></dropzone>

                <div id="files-holder" :class="{ 'grid-view' : grid, 'list-view' : !grid  }">
                    
                    <div class="mt-4">
                        <div v-if='!files[ ft.id ].length' class="row">
                            <div class="col-md-12 file-item file-no">
                                <div class="alert alert-info">
                                    <span class="icon icon-info"></span> 
                                    Няма качени файлове в тази категория.
                                </div>
                            </div>
                        </div>
                        
                        <div v-if='files[ ft.id ].length'>

                            <file-grid :files='files[ ft.id ]' 
                                       :conf='fileConfig'
                                       :params='{ ftid : ft.id }'
                                       v-on:file-removed='fileRemoved'></file-grid>
                       
                        </div>
                    </div>    

                </div>
            </div>
        </div>
    </div>
</div>

</template>

<script>
    export default {

        mounted() {
            this.getData();
        },

        created() {
           
        },

        //Project ID
        props : ['pid'],

        data() {
            return {

                fileConfig : {
                    info        : "Качено от възложител в Обща информация",
                    lightBoxId  : 'own-edit',
                    download    : true,
                    removeUrl   : 'prj:rmfl',
                    remove      : true,
                    edit        : true
                },

                isReady     : false,
                files       : false,
                grid        : true,
                numFiles    : 0,
                fileTypes   : [],

                dzConf : {
                    id : 'dz-1',
                    url     : '/system/fls:up',
                    remove  : true,
                    params  : {
                        tid : 1,
                        pid : this.pid,
                        _token : this.csrf
                    }
                },
            }
        },

        methods : {

            getData() {
                var me = this;

                me.ajax.call('prj:fls', { p : me.$route.params.id }, (r) => {

                    if( r.status == 'success' ) {
                        var files = {};
                        me.fileTypes = r.data.ft;

                        if( r.data.f.length ) {
                            bus.$emit('has-files');
                        }

                        me.numFiles = r.data.f.length;

                        for( var i in me.fileTypes ) {
                            files[ me.fileTypes[i].id ] = [];
                        }

                        for( var i in r.data.f ) {
                            files[ r.data.f[i].type_id ].push( r.data.f[i] );
                        }

                        me.files = files;
                    }

                })

            },

            fileRemoved( i, params ) {

                if( typeof this.files[ params.ftid ] != 'undefined' ) {
                    this.files[ params.ftid ].splice( i, 1 );

                    this.numFiles--;

                    if( !this.numFiles ) {
                        bus.$emit('has-files',false);
                    }
                }

            },

            addFile( f ) {

                this.files[ f.type_id ].push( f ); 

                $.notify("Файлът беше качен успешно","success");

                bus.$emit('has-files');
            },

            getConfig( ft ) {

                return {
                    id  : 'dz' + ft.id,
                    url : '/system/fls:up',
                    params : {
                        tid : ft.id,
                        pid : this.pid
                    }
                };

            },

            deleteImage( id, i, t ) {
                var me = this;

                if( ! confirm("Сигурни ли сте?") ) {
                    return;
                }

                me.ajax.call('prj:rmfl', { f : id }, (r) => {
                    
                    if( r.status == 'success' ) {

                        me.files[ t ].splice( i, 1 );

                        $.notify("Файлът беше премахнат успешно",'success');
                    }

                })
            }


        }

    }
</script>